export const events = {
  addTimeOffStart: 'Add time off start',
  addTimeOffSubmit: 'Add time off submit',
  exportEmployeeListStart: 'Export employee list start',
  exportEmployeeListSubmit: 'Export employee list submit',
  reviewTimeOffRequestStart: 'Review time off request start',
  reviewTimeOffRequestSubmit: 'Review time off request submit',

  blockedPeriods: {
    modifyBlockedPeriodSubmit: 'Modify blocked period submit',
    modifyBlockedPeriodStart: 'Modify blocked period start',
  },

  policyAssignments: {
    createPolicyAssignmentSubmit: 'Create policy assignment submit',
    updatePolicyAssignmentSubmit: 'Update policy assignment submit',
    deletePolicyAssignmentSubmit: 'Delete policy assignment submit',
  },

  leaveApprovalRecommendation: {
    approveLeave: 'Approve leave',
    rejectLeave: 'Reject leave',
    shiftsRedirectClicked: 'Shifts redirect clicked',
    shiftsModalClosed: 'Shifts modal closed',
    personalizedRuleModal: {
      buttonViewed: 'Personalized rule button viewed',
      modalOpened: 'Personalized rule modal opened',
      imInterestedClicked: 'Personalized rule modal Im interested clicked',
    },
  },
}
